import { CALL_HISTORY_METHOD, LOCATION_CHANGE } from 'redux-first-history'
import reduxStoreReducer from './legacy'
import newReduxStoreReducer from './new-redux'
import { consentReducer } from 'modules/consent/reducers'
import { CONSENT_DOMAIN, CONSENT_ACTION } from 'modules/consent/constants'

function createMainReducer (routerReducer) {
  return (state, action) => {
    const { reduxType } = action
    const type = reduxType || action.type
    if (
      reduxType &&
      Object.prototype.hasOwnProperty.call(newReduxStoreReducer, type)
    ) {
      return newReduxStoreReducer[type](state, action)
    }

    // Consent reducer
    if (Object.values(CONSENT_ACTION).includes(action.type)) {
      state = {
        ...state,
        [CONSENT_DOMAIN]: consentReducer(state?.[CONSENT_DOMAIN], action)
      }
      return state
    }

    // Store action
    if (Object.prototype.hasOwnProperty.call(reduxStoreReducer, action.type)) {
      return reduxStoreReducer[action.type](state, action)
    }

    // Router action
    if ([
      LOCATION_CHANGE,
      CALL_HISTORY_METHOD
    ].includes(action.type)) {
      state = {
        ...state,
        router: routerReducer(state?.router, action)
      }
    }

    // Unknown action
    return state
  }
}

export default createMainReducer
